// API Configuration
// Centralized API URL configuration for the application

const isDev = process.env.NODE_ENV === 'development';

// Production API URL - update this when the backend URL changes
const PROD_API_URL = 'https://api.intunemermaid.com/api';

// Prefer explicit override when provided (e.g. Docker Compose)
const OVERRIDE_API_URL = process.env.REACT_APP_API_BASE_URL;

// In development, default to /api (CRA proxy) unless an override is set
// In production, use the full API URL unless overridden
export const API_BASE_URL = OVERRIDE_API_URL && OVERRIDE_API_URL.trim() !== ''
	? OVERRIDE_API_URL
	: (isDev ? '/api' : PROD_API_URL);

export default API_BASE_URL;
